import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '@app/_models';
import { UserService, AlertService } from '@app/_services';


@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css'],
    standalone: false
})
export class PasswordResetComponent implements OnInit
{

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
        private alertService: AlertService)
    { }

    formSubmitted = false;
    formLoading = false;
    form1: UntypedFormGroup;
    formErrorMessage: string;

    showResetForm = true;
    showResetConfirm = false;
    passwordResetToken: String;
    user: User;

    validationMessages = {
        'password': [
            { type: 'required', message: 'Password is required' },
            { type: 'minlength', message: 'Password must be at least 8 characters long' },
            { type: 'invalid', message: 'Passwords do not match' }
        ],
        'confirmPassword': [
            { type: 'invalid', message: 'Passwords do not match' }
        ]
    };

    ngOnInit()
    {
        this.passwordResetToken = this.activatedRoute.snapshot.queryParamMap.get('token');

        this.form1 = this.fb.group({
            passwordResetToken: [this.passwordResetToken],
            passwordGroup: this.fb.group({
                password: ['', [Validators.compose([
                    Validators.minLength(8),
                    Validators.required,
                    Validators.pattern('^(?=.*[0-9])[a-zA-Z0-9#?!@$%^&*-]+$'),

                ])]],
                confirmPassword: ['']
            }, { validators: this.passwordMatchValidator })

        });
    }

    onPasswordUpdateSubmit()
    {
        this.formSubmitted = true;

        // stop here if form is invalid
        if (this.form1.invalid)
        {
            return;
        }
        console.log(JSON.stringify(this.form1.value));

        this.user = new User();

        this.user.password = this.form1.value.passwordGroup.password;
        this.user.passwordResetToken = String(this.passwordResetToken);

        this.formLoading = true;
        this.userService.resetPassword(this.user)
            .pipe(first())
            .subscribe(
                res =>
                {
                    console.log('user-password.component SUCCESS: ' + JSON.stringify(res));
                    this.showResetConfirm = true;
                    this.showResetForm = false;
                },
                err =>
                {
                    console.log('user-password.component FAIL: ' + JSON.stringify(err));
                    this.formErrorMessage = err.error.message
                    this.formLoading = false;
                },
                () => { this.formLoading = false; });
    }

    passwordMatchValidator(c: AbstractControl)
    {
        if (c.get('password').value !== c.get('confirmPassword').value)
        {
            c.get('confirmPassword').setErrors({ invalid: true });
        }
    }
}
